import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    paper: {
        maxWidth: '1005px',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(1),
        backgroundColor: '#606060'
    },
    headerGrid: {
        paddingTop: '2rem',
        paddingLeft: '1rem',
        textAlign: 'center'
    },
    mapGrid: {
        padding: '1rem'
    },
    mapContainer: {
        maxWidth: '1005px',
        height: '500px',
        overflow: 'hidden',
    },
    mapIframe: {
        width: '100%',
        overflow: 'hidden'
    }
})

class RainMapComponent extends React.Component {
    render() {
        const { classes } = this.props

        return (
            <Grid container direction="row">
                <Grid item xs={3} sm={2}></Grid>
                <Grid item xs={12} sm={4} className={classes.headerGrid}>
                    <Typography variant="h4">
                        Rain (Week)
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4} className={classes.headerGrid}>
                    <Typography variant="h4">
                        Rain (Day)
                    </Typography>
                </Grid>
                <Grid item xs={3} sm={2}></Grid>

                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4} className={classes.mapGrid}>
                    <Paper className={classes.paper} variant="outlined">
                        <div className={classes.mapContainer}>
                            <iframe height="500px" className={classes.mapIframe}
                                scrolling="no" title="fx." src="http://hydrologywp.selfip.com/hydrologyKL/googlemapweek.php"
                                frameBorder="yes" allowtransparency="true" allowFullScreen={true}>

                            </iframe>
                        </div>
                        <br />
                        <div style={{ textAlign: 'center' }}>
                            <img src="http://hydrologywp.selfip.com/images/heatmaplegend.png" alt="legend" />
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={4} className={classes.mapGrid}>
                    <Paper className={classes.paper} variant="outlined">
                        <div className={classes.mapContainer}>
                            <iframe height="500px" className={classes.mapIframe}
                                scrolling="no" title="fx." src="http://hydrologywp.selfip.com/hydrologyKL/googlemapday.php"
                                frameBorder="yes" allowtransparency="true" allowFullScreen={true}>

                            </iframe>
                        </div>
                        <br />
                        <div style={{ textAlign: 'center' }}>
                            <img src="http://hydrologywp.selfip.com/images/heatmaplegend.png" alt="legend" />
                        </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={2}></Grid>
            </Grid>
        )
    }
}

export default withStyles(styles, { withTheme: true })(RainMapComponent);